import React from 'react'
import { useAppSelector } from '../redux/hooks'
import User, { RoleType } from '../models/User'
import { selectUserData } from '../redux/actions/login/loginSlice'
const ActiveMarkets = React.lazy(() => import('../admin-app/pages/active-matches/active-markets'))
const ActiveMatches = React.lazy(() => import('../admin-app/pages/active-matches/active-matches'))
const GetAllFancy = React.lazy(() => import('../admin-app/pages/active-matches/get-all-fancy'))
const MatchesPage = React.lazy(() => import('../admin-app/pages/add-matches/matches'))
const SeriesPage = React.lazy(() => import('../admin-app/pages/add-matches/series'))
const SportsPage = React.lazy(() => import('../admin-app/pages/add-matches/sports'))
const AddUser = React.lazy(() => import('../admin-app/pages/add-user/add-user'))
const ListClients = React.lazy(() => import('../admin-app/pages/list-clients/list-clients'))
const Bank = React.lazy(() => import('../admin-app/pages/bank/bank'))
const MainAdmin = React.lazy(() => import('../admin-app/pages/_layout/MainAdmin'))
const Message = React.lazy(() => import('../admin-app/pages/settings/message'))
const Paymethod = React.lazy(() => import('../admin-app/pages/settings/paymethod'))
const UndeclaredBets = React.lazy(() => import('../admin-app/pages/undeclared-bets/undeclared-bets'))
const SeriesSettings = React.lazy(() => import('../admin-app/pages/settings/series-settings'))
const UserWithoutDeposit = React.lazy(() => import('./pages/transaction-statement/UserWithoutdeposite'))
const AdminDashboard = React.lazy(
  () => import('../admin-app/pages/admin-dashboard/admin-dashboard'),
)

const SubDashboard = React.lazy(() => import('../admin-app/pages/admin-dashboard/subdashboard'))
const AccountStatementAdmin = React.lazy(
  () => import('../admin-app/pages/AccountStatement/AccountStatementAdmin'),
)

const DepositStatementAdmin = React.lazy(
  () => import('../admin-app/pages/transaction-statement/DepositStatementAdmin'),
)
const WithdrawStatementAdmin = React.lazy(
  () => import('../admin-app/pages/transaction-statement/WithdrawStatementAdmin'))
const ProfitLossAdmin = React.lazy(() => import('../admin-app/pages/PlReport/ProfitLossAdmin'))
const UserHistoryAdmin = React.lazy(() => import('../admin-app/pages/UserHistory/UserHistoryAdmin'))
const CasinoResultAdmin = React.lazy(() => import('../admin-app/pages/CasinoResult/CasinoResultAdmin'))
const TurnoverAdmin = React.lazy(() => import('../admin-app/pages/Turnover/TurnoverAdmin'))
const UserAuthAdmin = React.lazy(() => import('../admin-app/pages/UserAuth/UserAuthAdmin'))
const UserRegisterAdmin = React.lazy(() => import('../admin-app/pages/UserRegister/UserRegisterAdmin'))
const TotalProfitLossAdmin = React.lazy(
  () => import('../admin-app/pages/TotalProfitLoss/TotalProfitLossAdmin'),
)
const UserWinLossAdmin = React.lazy(() => import('../admin-app/pages/UserWinLoss/UserWinLossAdmin'))
const UnsetteleBetHistoryAdmin = React.lazy(
  () => import('../admin-app/pages/UnsetteleBetHistory/UnsetteleBetHistoryAdmin'),
)
const Odds = React.lazy(() => import('../pages/odds/odds'))
const ChangePassword = React.lazy(() => import('../pages/ChangePassword/ChangePassword'))
const AuthLayout = React.lazy(() => import('../pages/_layout/AuthLayout'))
const Login = React.lazy(() => import('./pages/login/login'))
const AdminCasinoGame = React.lazy(() => import('./pages/casino-games/AdminCasinoGame'))
const CasinoList = React.lazy(() => import('./pages/casino-list/casino-list'))
const MultiLoginAdmin = React.lazy(() => import('./pages/MultiLogin/MultiLoginAdmin'))
const AdminCasinoHub = React.lazy(() => import('./pages/casino-games/AdminCasinoHub'))
const GameReportAdmin = React.lazy(() => import('./pages/GameReports/GameReportAdmin'))
const LedgerAdmin = React.lazy(() => import('../admin-app/pages/Ledger/LedgerAdmin'))
const UserBookAdmin = React.lazy(() => import('../admin-app/pages/UserBook/UserBookAdmin'))
const MatchSetting = React.lazy(() => import('../admin-app/pages/match-setting/match-setting'))
const Rules = React.lazy(() => import('./pages/Rules/rules'))
const Tc = React.lazy(() => import('./pages/Rules/tc'))
const AnalysisProfitloss = React.lazy(() => import('./pages/Anaysis-pl/AnalysisProfitloss'))
const AdminHome = React.lazy(() => import('./pages/admin-dashboard/AdminHome'))
const InplayMatch = React.lazy(() => import('./pages/InplayMatch/InplayMatch'))
const AddSubuser = React.lazy(() => import('../admin-app/pages/settings/permision/AddSubuser'))
const UpdateSubuser = React.lazy(() => import('../admin-app/pages/settings/permision/UpdateSubuser'))
const Affiliate = React.lazy(() => import('./pages/Affilate/addAffilate'))
const AffiliateList = React.lazy(() => import('./pages/Affilate/ListNverify'))
const AffiliateUserList = React.lazy(() => import('./pages/Affilate/AffilateUser'))
const AffilateCommission = React.lazy(() => import('./pages/Affilate/AffilateComm'))
const AffilateTransection = React.lazy(() => import('./pages/Affilate/AffilateTransection'))
const AffilateReport = React.lazy(() => import('./pages/Affilate/AffilateReport'))
const SecurityMonitoring = React.lazy(() => import('./pages/security-monitoring/SecurityMonitoring'))
const AdminRoutes = () => {
  const userState = useAppSelector<{ user: User }>(selectUserData)
  React.useEffect(() => {
    console.log('🔍 AdminRoutes - userState:', userState)
    console.log('🔍 AdminRoutes - userState.user:', userState?.user)

  }, [userState])
  const hasSubusers = Array.isArray(userState?.user?.subusers) && userState.user.subusers.length > 0

  // build the index route object beforehand
  const indexRoute = hasSubusers
    ? { index: true, element: <SubDashboard /> }
    : { index: true, element: <AdminHome /> }
  return [
    {
      path: '/admin',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: <Login /> },
        {
          path: '',
          element: <MainAdmin />,
          children: [
             indexRoute,
            { path: 'home', element: <AdminHome /> },
            { path: 'dashbaord', element: <AdminDashboard /> },
            { path: 'market-analysis', element: <AdminDashboard /> },
            { path: 'multi-login', element: <MultiLoginAdmin /> },
            ...['bank', 'bank/:username'].map((path) => ({
              key: 'bank',
              path,
              element: <Bank />,
            })),
            { path: 'our-casino', element: <AdminCasinoHub hub='our' /> },
            { path: 'virtual-casino', element: <AdminCasinoHub hub='virtual' /> },
            { path: 'vip-casino', element: <AdminCasinoHub hub='vip' /> },
            { path: 'premium-casino', element: <AdminCasinoHub hub='premium' /> },
            { path: 'odds/:matchId', element: <Odds /> },
            ...['list-clients', 'list-clients/:username'].map((path) => ({
              key: 'list-client',
              path: path,
              element: <ListClients />,
            })),
            ...['add-user', 'add-user/:username'].map((path) => ({
              key: 'add-user',
              path: path,
              element: <AddUser />,
            })),
            { path: 'rules', element: <Rules /> },
            { path: 'terms', element: <Tc /> },
            ...(userState.user.role === RoleType.admin || userState.user.role === RoleType.sadmin
              ? [
                { path: 'sports-list/:url?', element: <SportsPage /> },
                { path: 'series/:sportId', element: <SeriesPage /> },
                { path: 'matches/:sportId', element: <MatchesPage /> },
                { path: 'active-matches/:sportId/:matchType?', element: <ActiveMatches /> },
                { path: 'active-markets/:matchId', element: <ActiveMarkets /> },
                { path: 'active-fancies/:matchId', element: <GetAllFancy /> },
                { path: 'undeclared-bets', element: <UndeclaredBets /> },
                { path: 'messages', element: <Message /> },
                { path: 'series-settings', element: <SeriesSettings /> },
              ]
              : []),
            { path: 'change-password', element: <ChangePassword /> },
            ...(userState.user.role !== RoleType.user
              ? [{ path: 'security-monitoring', element: <SecurityMonitoring /> }]
              : []),
            { path: 'accountstatement', element: <AccountStatementAdmin /> },
            { path: 'profitloss', element: <ProfitLossAdmin /> },
            { path: 'userhistory', element: <UserHistoryAdmin /> },
            { path: 'casinoresult', element: <CasinoResultAdmin /> },
            { path: 'turnover', element: <TurnoverAdmin /> },
            { path: 'authlist', element: <UserAuthAdmin /> },
            { path: 'userregisterdetail', element: <UserRegisterAdmin /> },
            { path: 'totalprofitloss', element: <TotalProfitLossAdmin /> },
            { path: 'userwinloss', element: <UserWinLossAdmin /> },
            { path: 'unsettledbet', element: <UnsetteleBetHistoryAdmin /> },
            { path: 'unsettledbet/:type', element: <UnsetteleBetHistoryAdmin /> },
            { path: 'casino/:gtype', element: <AdminCasinoGame /> },
            { path: 'casino-list', element: <CasinoList /> },
            { path: 'game-reports', element: <GameReportAdmin /> },
            { path: 'depositstatement', element: <DepositStatementAdmin /> },
            { path: 'withdrawstatement', element: <WithdrawStatementAdmin /> },
            { path: 'payment-method', element: <Paymethod /> },
            { path: 'ledger', element: <LedgerAdmin /> },
            { path: 'user-book', element: <UserBookAdmin /> },
            { path: 'match-settings/:matchId', element: <MatchSetting /> },
            { path: 'analysis-pl', element: <AnalysisProfitloss /> },
            { path: 'inplay-matches', element: <InplayMatch /> },
            { path: 'add-subuser', element: <AddSubuser /> },
            { path: 'update-subuser', element: <UpdateSubuser /> },
            { path: 'affiliate', element: <Affiliate /> },
            { path: 'affiliate-verify', element: <AffiliateList /> },
            { path: 'affiliate-list', element: <AffiliateUserList /> },
            { path: 'affiliate-commission', element: <AffilateCommission /> },
            { path: 'affiliate-settlement', element: <AffilateTransection /> },
            { path: 'commission-report', element: <AffilateReport /> },
            { path: 'user-without-deposit', element: <UserWithoutDeposit /> },
          ],
        },
      ],
    },
  ]
}

export default AdminRoutes
